<template>
  <div class="login-content-box">
    <div class="login-content-box-1">
      <div class="login-content-box-1-top">
        <p class="p2" @click="linkEx2">密码登录</p>
        <p class="p2 active" @click="linkEx">验证码登录</p>
      </div>
      <div class="login-content-box-1-bottom">
        <Form
          class="F"
          ref="formInline"
          :model="formInline"
          :rules="ruleInline"
          @keyup.enter.native="handleSubmit('formInline')"
        >
          <FormItem class="F-1" prop="phone">
            <Input class="I" type="text" v-model="formInline.phone" placeholder="手机号" />
          </FormItem>
          <FormItem class="F-1" prop="imgCode">
            <Input class="I" v-model="formInline.imgCode" placeholder="图片验证码" />
            <img
              class="code"
              :src="code.image"
              alt="图片验证码"
              v-if="code && code.image"
              @click="getCode"
            />
          </FormItem>

          <FormItem class="F-1 form-code-item" prop="captcha">
            <Input type="text" class="I" v-model="formInline.captcha" placeholder="验证码：" />
            <Button type="text" v-if="showCode" @click="getCaptcha" class="form-code-btn">获取验证码</Button>
            <Button type="text" v-else disabled class="form-code-btn">{{count}}s后重新获取</Button>
          </FormItem>

          <Button
            type="primary"
            @click="handleSubmit('formInline')"
            size="large"
            :loading="loading"
            style="margin-top: 24px;"
          >登录</Button>
          <p class="login-re">
            <span @click="$router.push('/login/register')">没有账号？立即注册</span>
          </p>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import { mapActions, mapMutations } from "vuex";

export default {
  name: "b-login",
  data() {
    return {
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      formInline: {
        phone: "",
        imgCode: "",
        captcha: ""
      },
      ruleInline: {
        phone: validator.phone,
        imgCode: [
          { required: true, message: "请输入正确的图片验证码", trigger: "blur" }
        ],
        captcha: [
          {
            required: true,
            message: "请输入正确的验证码",
            trigger: "blur"
          }
        ]
      },
      code: null, // 二维码信息
      remember: true, // 二维码信息
      loading: false
    };
  },
  async created() {
    this.getCode();
  },
  methods: {
    ...mapMutations({
      setUser: "setUser",
      setToken: "setToken",
      setLogin: "setLogin",
      setTokenTime: "setTokenTime"
    }),
    ...mapActions({
      getToken: "loginModule/getToken",
      getMsgCode: "loginModule/getMsgCode",
      getUser: "loginModule/getUser",
      getImgCode: "loginModule/getImgCode",
      validateImgCode: "loginModule/validateImgCode",
      validateMsgCode: "loginModule/validateMsgCode"
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let codeValid = await this.validMsgCode();
      if (!codeValid) return;
      let formData = {
        grant_type: "password",
        client_id: "cloud.exhibition",
        client_secret: "secret",
        username: form.phone,
        password: "000000",
        scope: "synair offline_access",
        login_type: "phonecode"
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let tokenData = await this.getToken(formData);
      if (tokenData) {
        this.$Message.success("登录成功");
        this.setToken(tokenData.access_token);
        this.setTokenTime(tokenData.expires_in * 1000 + new Date().getTime());
        let user = await this.getUser();
        this.setLogin(true);
        this.$router.push("/home");
      }
      this.loading = false;
    },
    async getCode() {
      // 获取code
      this.code = await this.getImgCode();
    },
    async downTime() {
      const valid = await this.getMsgCode(this.formInline.phone);
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async getCaptcha() {
      this.$refs.formInline.validateField("phone", val => {});
      this.$refs.formInline.validateField("imgCode", val => {});
      let codeValid = await this.validCode();
      if (!codeValid) return;
      this.$refs.formInline.validateField("phone", val => {
        if (val !== "") return;
        this.downTime();
      });
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async validMsgCode() {
      // 验证code
      if (!this.formInline.captcha) return false;
      let valid = this.validateMsgCode({
        Phone: this.formInline.phone,
        Code: this.formInline.captcha
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        this.$Message.error(valid.errors[0].description);
        return false;
      }
      return true;
    },
    async validCode() {
      // 验证code
      if (!this.code || !this.formInline.imgCode) return false;
      let valid = await this.validateImgCode({
        Key: this.code.key,
        Code: this.formInline.imgCode
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        this.$Message.error(valid.errors[0].description);
        this.getCode();
        return false;
      }
      return true;
    },
    linkEx() {
      this.$router.push("/login/blogin");
    },
    linkEx2() {
      this.$router.push("/login/alogin");
    }
  }
};
</script>

<style lang='scss' scoped>
.F { 
  .code {
    width: 70px;
    height: 26px;
    position: absolute;
    top: 27px;
    right: 8px;
    cursor: pointer;
  }
}
</style>
<style lang='scss'>
.F {
  display: flex;
  flex-direction: column;
  width: 360px;
  height: 350px;
  position: relative;
  .ivu-input {
    height: 42px;
  }
  &-1 {
    margin-top: 15px;
    margin-bottom: 0;
    .I {
      margin-top: 19px;
    }
  }
  .F-2 {
    width: 100%;
    height: 15px;
    line-height: 15px;
    display: flex;
    justify-content: flex-end;
    margin: 24px 0;
    .F-2-text {
      width: 60px;
      height: 13px;
      cursor: pointer;
      font-size: 14px;
      color: #666;
    }
  } 
}
.login-content-box {
  width: 420px;
  min-height: 392px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(100, 100, 100, 0.38);
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  &-1 {
    width: 420px;
    min-height: 348px;
    background-color: #fff;
    border-radius: 2px;
    position: relative;
    &-top {
      width: 332px;
      height: 40px;
      margin: 40px auto 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .p1 {
        width: 91px;
        height: 17px;
        font-size: 18px;
        line-height: 16px;
        color: #808080;
        cursor: pointer;
        font-weight: bold;
      }
      .p2 {
        height: 19px;
        font-size: 18px;
        line-height: 16px;
        cursor: pointer;
        color: #666;
        &.active,
        &:hover {
          color: #d13119;
        }
      }
      .p3 {
        color: #808080;
        &:hover {
          color: #d13119;
        }
      }
    }
    &-bottom {
      width: 360px;
      min-height: 350px;
      margin: 0 auto;
    }
  }
  .wx-icon {
    width: 22px;
    height: 22px;
    padding: 3px 5px;
    background-color: #3eb135;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
    img {
      width: 13px;
      height: 11px;
    }
  }
}
.form-code-item {
  position: relative;
  .form-code-btn {
    position: absolute;
    right: -2px;
    top: 24px;
    border: none;
    outline: none;
    background: transparent !important;
    color: #1890ff;
    &:focus {
      box-shadow: none;
      border: none;
      outline: none;
    }
  }
}
.login-re {
  text-align: center;
  margin-top: 20px;
  span {
    text-decoration: underline;
    font-size: 14px;
    color: #666;
    cursor: pointer;
  }
}
</style>